let client = null;
export const setGraphQLClient = graphQLClient => {
  client = graphQLClient;
};
export const getGraphQLClient = () => {
  return client;
};